import { render, staticRenderFns } from "./TemplateDesignerV2.vue?vue&type=template&id=27664cd4&scoped=true"
import script from "./TemplateDesignerV2.vue?vue&type=script&lang=js"
export * from "./TemplateDesignerV2.vue?vue&type=script&lang=js"
import style0 from "./TemplateDesignerV2.vue?vue&type=style&index=0&id=27664cd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27664cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27664cd4')) {
      api.createRecord('27664cd4', component.options)
    } else {
      api.reload('27664cd4', component.options)
    }
    module.hot.accept("./TemplateDesignerV2.vue?vue&type=template&id=27664cd4&scoped=true", function () {
      api.rerender('27664cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/print-template/TemplateDesignerV2.vue"
export default component.exports